(() => {
  const root = document.querySelector('[data-intro-lookup]');
  if (!root) return;
  const year = root.querySelector('[data-year]');
  const make = root.querySelector('[data-make]');
  const model = root.querySelector('[data-model]');
  const status = root.querySelector('[data-status]');
  const results = root.querySelector('[data-results]');
  let rows = [];

  const unique = values => [...new Set(values)].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
  const setOptions = (select, values, placeholder) => {
    select.replaceChildren(new Option(placeholder, ''));
    values.forEach(value => select.add(new Option(value, value)));
    select.disabled = values.length === 0;
  };
  const inYear = row => Number(year.value) >= row.year_start && Number(year.value) <= row.year_end;

  const render = () => {
    results.replaceChildren();
    if (!model.value) {
      status.textContent = '';
      return;
    }
    const matches = rows.filter(row => inYear(row) && row.make === make.value && row.model === model.value);
    const available = [...new Set(matches.map(row => row.line_name))];
    status.textContent = matches.length
      ? `${matches.length} available shade page${matches.length === 1 ? '' : 's'}: ${available.join(', ')}. Check the fitment note before ordering.`
      : 'No Intro-Tech shade page is available for this vehicle. Please choose another vehicle or contact us.';
    matches.forEach(row => {
      const card = document.createElement('article');
      card.className = 'intro-ultimate__result';
      const lineCard = root.querySelector(`[data-line-card="${row.line}"]`);
      if (lineCard) {
        const sourceImage = lineCard.querySelector('img');
        const imageLink = document.createElement('a');
        imageLink.className = 'intro-ultimate__result-image';
        imageLink.href = `/products/${encodeURIComponent(row.handle)}`;
        const image = document.createElement('img');
        image.src = sourceImage.src;
        image.alt = sourceImage.alt;
        image.loading = 'lazy';
        image.width = 800;
        image.height = 600;
        imageLink.append(image);
        card.append(imageLink);
      }
      const copy = document.createElement('div');
      copy.className = 'intro-ultimate__result-copy';
      const title = document.createElement('h3');
      title.textContent = row.title;
      const fit = document.createElement('p');
      fit.textContent = `${row.year_start}–${row.year_end} ${row.make} ${row.model}`;
      const note = document.createElement('p');
      note.className = 'intro-ultimate__note';
      note.textContent = row.note ? `Fitment note: ${row.note}` : 'No additional fitment note';
      const sku = document.createElement('p');
      sku.textContent = `Part number: ${row.sku}`;
      const price = document.createElement('p');
      price.textContent = `$${row.price}`;
      const link = document.createElement('a');
      link.href = `/products/${encodeURIComponent(row.handle)}`;
      link.textContent = `View ${row.title}`;
      copy.append(title, fit, note, sku, price, link);
      card.append(copy);
      results.append(card);
    });
  };

  year.addEventListener('change', () => {
    setOptions(make, year.value ? unique(rows.filter(inYear).map(row => row.make)) : [], 'Select a make');
    setOptions(model, [], 'Select a make first');
    render();
  });
  make.addEventListener('change', () => {
    setOptions(model, make.value ? unique(rows.filter(row => inYear(row) && row.make === make.value).map(row => row.model)) : [], 'Select a model');
    render();
  });
  model.addEventListener('change', render);

  fetch(root.dataset.fitmentsUrl)
    .then(response => { if (!response.ok) throw new Error('Fitment file unavailable'); return response.json(); })
    .then(data => {
      rows = data;
      if (!Array.isArray(rows)) throw new Error('Invalid fitment file');
      const years = unique(rows.flatMap(row => Array.from({ length: row.year_end - row.year_start + 1 }, (_, index) => row.year_start + index))).reverse();
      setOptions(year, years, 'Select a year');
      setOptions(make, [], 'Select a year first');
      setOptions(model, [], 'Select a make first');
      status.textContent = '';
    })
    .catch(() => { status.textContent = 'The fitment list could not load. Please try again later.'; });
})();
